import React, { useEffect, useRef, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import Home from "../pages/Home";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import WhatsAppFloat from "../components/whatsappFloat";
// import AboutUs from "../../pages/root/AboutUs";
// import FindMentor from "../../pages/root/FindMentor";
// import BecomeMentor from "../../pages/root/BecomeMentor";
// import AiCareer from "../../pages/root/AiCareer";
// import ContactUs from "../../pages/root/ContactUs";
// import Scholarship from "../../pages/root/Scholarship";
// import Blog from "../../pages/root/Blog";
// import CareerGuide from "../../pages/root/CareerGuide";

// import ThemedLoader from "../root/ThemedLoader";
// import logo from "../../assets/new images/logo.png";
// import Roles from "../../pages/root/Roles";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// Extract all background-image URLs from a container
function collectBackgroundUrls(rootEl) {
  if (!rootEl) return [];
  const els = Array.from(rootEl.querySelectorAll("*"));
  const urls = new Set();
  const regex = /url\((?:'|")?([^"')]+)(?:'|")?\)/g;

  els.forEach((el) => {
    const style = window.getComputedStyle(el);
    const bg = style.backgroundImage;
    if (!bg || bg === "none") return;

    // handle multiple urls in one property
    let match;
    while ((match = regex.exec(bg)) !== null) {
      if (match[1]) urls.add(match[1]);
    }
  });

  return Array.from(urls);
}

function RootLayout() {
  const [loading, setLoading] = useState(true);
  const [fadeOut, setFadeOut] = useState(false); // for smooth exit
  const contentRef = useRef(null);
  const { pathname } = useLocation();

  useEffect(() => {
    // Allow route content to render so we can detect images present in the DOM
    const raf = requestAnimationFrame(() => {
      const container = contentRef.current || document.body;

      const imgs = Array.from(container.querySelectorAll("img"));
      const bgUrls = collectBackgroundUrls(container);

      const total = imgs.length + bgUrls.length;

      if (total === 0) {
        // Nothing to load → exit quickly
        setFadeOut(true);
        const to = setTimeout(() => setLoading(false), 300);
        return () => clearTimeout(to);
      }

      let loaded = 0;
      const mark = () => {
        loaded += 1;
        if (loaded >= total) {
          // Smooth fade-out
          setFadeOut(true);
          const to = setTimeout(() => setLoading(false), 300);
          cleanup(); // remove listeners
          clearTimeout(fallback); // cancel fallback
          return () => clearTimeout(to);
        }
      };

      // Listeners cleanup
      const listeners = [];

      // Handle <img> tags
      imgs.forEach((img) => {
        if (img.complete && img.naturalWidth > 0) {
          mark();
        } else {
          const onLoad = () => mark();
          const onError = () => mark();
          img.addEventListener("load", onLoad);
          img.addEventListener("error", onError);
          listeners.push(() => {
            img.removeEventListener("load", onLoad);
            img.removeEventListener("error", onError);
          });
        }
      });

      // Handle CSS background images
      bgUrls.forEach((url) => {
        const probe = new Image();
        probe.onload = () => mark();
        probe.onerror = () => mark();
        probe.decoding = "async";
        probe.loading = "eager";
        probe.src = url;
        // No need to store listeners here (Image object gets GC'd)
      });

      // Safety fallback (in case a 3rd-party image never resolves)
      const fallback = setTimeout(() => {
        setFadeOut(true);
        const to = setTimeout(() => setLoading(false), 300);
        cleanup();
        return () => clearTimeout(to);
      }, 10000); // 10s max wait

      function cleanup() {
        listeners.forEach((off) => off());
      }

      // Clean on route change/unmount
      return () => {
        cleanup();
        clearTimeout(fallback);
      };
    });

    return () => cancelAnimationFrame(raf);
  }, [pathname]);

  return (
    <>
      <ScrollToTop />

      {/* LOADER OVERLAY (kept mounted above content) */}
      {/* {loading && (
        <ThemedLoader
          logo={logo}
          note="AI-Powered Career Guidance"
          className={`transition-opacity duration-500 ${
            fadeOut ? "opacity-0 pointer-events-none" : "opacity-100"
          }`}
        />
      )} */}

      {/* PAGE CONTENT (we still render while loading so we can detect images) */}
      <div ref={contentRef} className={`${loading ? "overflow-hidden" : ""}`}>
        <Navbar />

        <div className="w-full">
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </div>

        <Footer />
        <WhatsAppFloat/>
      </div>
    </>
  );
}

export default RootLayout;